<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" :fill="color || '#09B78A'" fill-opacity="0.15" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.0001 30.8788V15.293H26.0001V30.8788L32.293 24.5859L33.7072 26.0001L25.0001 34.7072L16.293 26.0001L17.7072 24.5859L24.0001 30.8788Z"
      :fill="color || '#09B78A'" 
    />
  </svg>
</template>

<script>
export default {
    props: ['color']
};
</script>

<style lang="scss" scoped></style>
